<template>
    <BreadCrumb PageTitle="Liste des demandes des inscriptions" />
    <ListeDemandeInscription/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeDemandeInscription from "@/components/DemandeInscription/ListeDemandeInscription.vue";
   
  
    export default defineComponent({
      name: "ListeDemandeInscriptionPage",
      components: {
        BreadCrumb,
        ListeDemandeInscription,
      },
    });
  </script>